import { SocialMediaPlatform } from '../components/SocialMedia/SocialMedia.types';
import zebitasAvatar from '../assets/avatars/zebitas_pfp.jpg';
import tvnautaAvatar from '../assets/avatars/tvnauta_pfp.jpg';
import arzielAvatar from '../assets/avatars/arziel_pfp.jpg';
import neoAvatar from '../assets/avatars/neo_pic.png';
import lzcAvatar from '../assets/avatars/lzcero_pfp.jpg';
import cukiAvatar from '../assets/avatars/cuki_pfp.jpg';
import perezAngelito from '../assets/avatars/angelito_pfp.jpg';
import paulaAvatar from '../assets/avatars/paula_pfp.png';
import shibiAvatar from '../assets/avatars/shibi_pfp.jpg';
import xlitoAvatar from '../assets/avatars/xlito_pfp.jpg';
import exxhyAvatar from '../assets/avatars/exxhy.png';
import systemAvatar from '../assets/avatars/system_pfp.jpg';
import kevAvatar from '../assets/avatars/kev_pfp.jpg';

export interface SocialMediaLink {
  socialMedia: SocialMediaPlatform;
  url: string;
}

export interface TeamMemberInformation {
  socialMedias: SocialMediaLink[];
  name: string;
  roleEn: string;
  roleEs: string;
  picture?: string;
}

export const leads: TeamMemberInformation[] = [
  {
    name: 'El Último TVNauta',
    roleEn: 'CO-CEO, Content Creator, Marketing Director',
    roleEs: 'CO-CEO, Creador de Contenido, Director de Mercadotecnia',
    picture: tvnautaAvatar,
    socialMedias: [
      {
        socialMedia: 'youtube',
        url: 'https://www.youtube.com/@Tv-Nauta',
      },
    ],
  },
  {
    name: 'Zebitas Martinex',
    roleEn: 'CO-CEO, Software Engineer, Team Lead',
    roleEs: 'CO-CEO, Ingeniero de Software, Team Lead',
    picture: zebitasAvatar,
    socialMedias: [
      {
        socialMedia: 'youtube',
        url: 'https://www.youtube.com/@ZebitasMartinex',
      },
      {
        socialMedia: 'instagram',
        url: 'https://www.instagram.com/zebitasmartinex/',
      },
    ],
  },
  {
    name: 'Arziel',
    roleEn: 'COO, Animator, Developer of "Caterva: Outsider Dreams"',
    roleEs: 'COO, Animador, Desarrollador de "Caterva: Outsider Dreams"',
    picture: arzielAvatar,
    socialMedias: [
      {
        socialMedia: 'youtube',
        url: 'https://www.youtube.com/@arziel_izq',
      },
      {
        socialMedia: 'instagram',
        url: 'https://www.instagram.com/arziel.izq/',
      },
      {
        socialMedia: 'twitter',
        url: 'https://www.twitter.com/arziel_Izq/',
      },
    ],
  },
];

export const developers: TeamMemberInformation[] = [
  {
    name: 'NEO Project',
    roleEn: 'Developer and Animator in "The Miracle Of San Martín"',
    roleEs: 'Desarrollador y Animador en "El Milagro de San Martín"',
    picture: neoAvatar,
    socialMedias: [
      {
        socialMedia: 'youtube',
        url: 'https://www.youtube.com/channel/UChEzRehSQjiMHFGetN1ELVQ',
      },
      {
        socialMedia: 'instagram',
        url: 'https://www.instagram.com/neoproject_st/',
      },
      {
        socialMedia: 'twitter',
        url: 'https://www.twitter.com/neoproject_st/',
      },
    ],
  },
  {
    name: 'JhowelBlond',
    roleEn: 'Developer and Animator in "The Miracle Of San Martín"',
    roleEs: 'Desarrollador y Animador en "El Milagro de San Martín"',
    socialMedias: [
      {
        socialMedia: 'instagram',
        url: 'https://www.instagram.com/jhowel_blond/',
      },
      {
        socialMedia: 'twitter',
        url: 'https://www.twitter.com/JhowelBlond/',
      },
    ],
  },
];

export const designers: TeamMemberInformation[] = [
  {
    name: 'Chucho Calderon',
    roleEn: 'Logo Designer and Illustrator',
    roleEs: 'Diseñador e Ilustrador de Logos',
    picture: lzcAvatar,
    socialMedias: [
      {
        socialMedia: 'youtube',
        url: 'https://www.youtube.com/@LZCOficial',
      },
      {
        socialMedia: 'instagram',
        url: 'https://www.instagram.com/lzcoficial/',
      },
      {
        socialMedia: 'twitter',
        url: 'https://www.twitter.com/LZCOficial/',
      },
    ],
  },
  {
    name: 'Cuki Kuin',
    roleEn: 'Web Designer',
    roleEs: 'Diseñadora Web',
    picture: cukiAvatar,
    socialMedias: [
      {
        socialMedia: 'youtube',
        url: 'https://www.youtube.com/@CukiKuin',
      },
      {
        socialMedia: 'instagram',
        url: 'https://www.instagram.com/cukizilla/',
      },
    ],
  },
  {
    name: 'Perez Angelito',
    roleEn: '3D Modeler for "The Miracle of San Martín"',
    roleEs: 'Modelador 3D para "El Milagro de San Martin"',
    picture: perezAngelito,
    socialMedias: [
      {
        socialMedia: 'twitter',
        url: 'https://www.twitter.com/perezAngelito/',
      },
    ],
  },
  {
    name: 'Paula Valiente',
    roleEn: 'Concept Artist for "The Miracle of San Martín"',
    roleEs: 'Artista conceptual para "El Milagro de San Martin"',
    picture: paulaAvatar,
    socialMedias: [
      {
        socialMedia: 'instagram',
        url: 'https://www.instagram.com/nasukichan/',
      },
      {
        socialMedia: 'youtube',
        url: 'https://www.youtube.com/@nasukichan',
      },
    ],
  },
  {
    name: 'Shibi Artwork',
    roleEn: 'Thumbnail illustrator for "Caterva: Outsider Dreams"',
    roleEs: 'Ilustradora de thumbnails para "Caterva: Outsider Dreams"',
    picture: shibiAvatar,
    socialMedias: [
      {
        socialMedia: 'instagram',
        url: 'https://www.instagram.com/shibicp16/',
      },
      {
        socialMedia: 'twitter',
        url: 'https://www.twitter.com/shibiartwork/',
      },
    ],
  },
  {
    name: 'XLito',
    roleEn: 'Asset illustrator for "Caterva: Outsider Dreams"',
    roleEs: 'Ilustrador de assets para "Caterva: Outsider Dreams"',
    picture: xlitoAvatar,
    socialMedias: [
      {
        socialMedia: 'instagram',
        url: 'https://www.instagram.com/thexlitos/',
      },
      {
        socialMedia: 'twitter',
        url: 'https://www.twitter.com/TheXlito/',
      },
    ],
  },
];

export const composers: TeamMemberInformation[] = [
  {
    name: 'VSystem',
    roleEn: 'Lead Composer for "The Miracle Of San Martín"',
    roleEs: 'Compositor para "El Milagro de San Martín"',
    picture: systemAvatar,
    socialMedias: [
      {
        socialMedia: 'youtube',
        url: 'https://www.youtube.com/@VSystem32',
      },
    ],
  },
  {
    name: 'Exxhy',
    roleEn: 'Lead Composer for "Caterva: Outsider Dreams"',
    roleEs: 'Compositor para "Caterva: Outsider Dreams"',
    picture: exxhyAvatar,
    socialMedias: [
      {
        socialMedia: 'soundcloud',
        url: 'https://soundcloud.com/exxhymusic/',
      },
    ],
  },
];

export const legalteam: TeamMemberInformation[] = [
  {
    name: 'Branses',
    roleEn: 'Advisor and legal representative',
    roleEs: 'Asesor y representante legal',
    socialMedias: [],
  },
  {
    name: 'Kev Marsh',
    roleEn: 'Official English Translator',
    roleEs: 'Traductora Oficial al Inglés',
    picture: kevAvatar,
    socialMedias: [
      {
        socialMedia: 'youtube',
        url: 'https://www.youtube.com/@KevMMarsh',
      },
      {
        socialMedia: 'instagram',
        url: 'https://www.instagram.com/maichelero/',
      },
      {
        socialMedia: 'twitter',
        url: 'https://www.twitter.com/KevMMarsh/',
      },
    ],
  },
];
